import React, { useEffect, useRef } from 'react'
import { ReactComponent as Neutral } from "../../Assets/iconsv2/moodIcons/neutral.svg"
import { ReactComponent as Romantic } from "../../Assets/iconsv2/moodIcons/romantic.svg"
import { ReactComponent as Humorous } from "../../Assets/iconsv2/moodIcons/humorous.svg"
import { ReactComponent as Casual } from "../../Assets/iconsv2/moodIcons/casual.svg"
import { ReactComponent as Supportive } from "../../Assets/iconsv2/moodIcons/supportive.svg"
import { ReactComponent as Business } from "../../Assets/iconsv2/moodIcons/business.svg"
import { ReactComponent as Formal } from "../../Assets/iconsv2/moodIcons/formal.svg"

import { ReactComponent as CloseIcon } from "../../Assets/iconsv2/generic/closeX.svg";
import styled from 'styled-components'
import { BUSINESS_MOOD, CASUAL_MOOD, FORMAL_MOOD, HUMOROUS_MOOD, NEUTRAL_MOOD, ROMANTIC_MOOD, SUPPORTIVE_MOOD } from '../../Constants/constantValues'
import { useTranslate } from '@tolgee/react';


const MoodItem = ({ mood, selected, onClick }) => {
    const { t } = useTranslate();

    const displayMoodIcon = (mood) => {
        let returnMood = <Neutral />
        switch (mood) {
            case ROMANTIC_MOOD:
                returnMood = <Romantic />
                break;
            case HUMOROUS_MOOD:
                returnMood = <Humorous />
                break;
            case CASUAL_MOOD:
                returnMood = <Casual />
                break;
            case SUPPORTIVE_MOOD:
                returnMood = <Supportive />
                break;
            case BUSINESS_MOOD:
                returnMood = <Business />
                break;
            case FORMAL_MOOD:
                returnMood = <Formal />
                break;
            default:
                break;
        }

        return returnMood
    }

    const displayMoodText = (mood) => {
        let returnMood = t('message_mood.neutral')

        switch (mood) {
            case ROMANTIC_MOOD:
                returnMood = t('message_mood.romantic')
                break;
            case HUMOROUS_MOOD:
                returnMood = t('message_mood.humorous')
                break;
            case CASUAL_MOOD:
                returnMood = t('message_mood.casual')
                break;
            case SUPPORTIVE_MOOD:
                returnMood = t('message_mood.supportive')
                break;
            case BUSINESS_MOOD:
                returnMood = t('message_mood.business')
                break;
            case FORMAL_MOOD:
                returnMood = t('message_mood.formal')
                break;
            default:
                break;
        }

        return returnMood
    }


    return (
        <ItemContainer selected={selected} onClick={onClick}>
            <IconWrapper selected={selected}>
                {displayMoodIcon(mood)}
            </IconWrapper>
            <p>{displayMoodText(mood)}</p>
        </ItemContainer>
    )
}

const MessageMoodSelector = ({ isMenuOpen, messageMood, closeModal, setMood }) => {
    const moods = [ROMANTIC_MOOD, HUMOROUS_MOOD, CASUAL_MOOD, NEUTRAL_MOOD, SUPPORTIVE_MOOD, BUSINESS_MOOD, FORMAL_MOOD];
    const ref = useRef();

    useEffect(() => {
        const checkIfClickedOutside = (e) => {
            if (isMenuOpen && ref.current && !ref.current.contains(e.target)) {
                closeModal(false);
            }
        };
        document.addEventListener("mousedown", checkIfClickedOutside);
        return () => {
            // Cleanup the event listener
            document.removeEventListener("mousedown", checkIfClickedOutside);
        };
    }, [isMenuOpen]);


    const handleSelectMood = (mood) => {
        setMood(mood);
        closeModal()
    }

    const { t } = useTranslate();
    return (
        <Container ref={ref}>


            <Line style={{ alignItems: "start", gap: "30px" }}>

                <SelectorWrapper>
                    <MiddleLIne />
                    {moods.map((mood, index) => (
                        <MoodItem
                            key={index}
                            mood={mood}
                            selected={mood === messageMood}
                            onClick={() => handleSelectMood(mood)}
                        />
                    ))}
                </SelectorWrapper>
                <CloseBtn onClick={closeModal}>
                    <CloseIcon />
                </CloseBtn>
            </Line>
            <Line style={{ justifyContent: "center" }}>
                <InfoText>
                    {t('message_mood.info')}
                </InfoText>
            </Line>


        </Container>
    )
}

export default MessageMoodSelector

const Container = styled.div`
display:flex;
flex-direction:column;
align-items:center;
background:${({ theme }) => theme.chat.messageInputWrapperBackground};
border-top:1px solid ${({ theme }) => theme.sidebar.borderColor};
z-index:10;
max-height:300px;
height:auto;
width:100%;
padding:16px;
justify-content:space-between;
gap:20px;

svg{
    color:white;
}
@media(max-width:990px){
    max-height:120px;
}
`
const ItemContainer = styled.div`
display:flex;
align-items:center;
jusify-content:center;
flex-direction:column;
gap:5px;
color:${({ theme }) => theme.chat.sentTime};
height:100%;
z-index:1;
cursor:pointer;

p{
color:${({ theme }) => theme.chat.sentTime};
text-align: center;
font-weight: 600;
font-size: 12px;
line-height: 16px;
letter-spacing: -0.24px;
}

${({ selected }) => selected ?
        (
            `
    p{
color:${({ theme }) => theme.chat.readIconColor};
text-align: center;
font-weight: 600;
font-size: 12px;
line-height: 16px;
letter-spacing: -0.24px;
}

    `)
        :
        (
            `
    p{
color:${({ theme }) => theme.chat.sentTime};
text-align: center;
font-weight: 600;
font-size: 12px;
line-height: 16px;
letter-spacing: -0.24px;
}

    `)
    }

${({ theme, selected }) => selected ?
        `
  p{
color:${theme.chat.readIconColor};
  }
  svg{
color:${theme.chat.readIconColor};
  }
  
  `
        : ``}
`
const MiddleLIne = styled.div`
height:3px;
display:flex;
width:100%;
margin:0 10px;
position:absolute;
top:20px;
background:${({ theme }) => theme.chat.mediaBtnBackground};
z-index:0;
`
const CloseBtn = styled.button`
display:flex;
align-items:center;
background:none;
border:none;
cursor:pointer;
margin-top:20px;

`
const Line = styled.div`
display:flex;
gap:10px;
align-items:center;
justify-content:space-between;
width:100%;
position:relative;
`
const SelectorWrapper = styled.div`
display:flex;
align-items:center;
position:relative;
width:100%;
justify-content:space-between;
gap:10px;
overflow:hidden;
@media(max-width:990px){
gap:5px;
}
`

const IconWrapper = styled.div`
display:flex;
align-items:center;
justify-content:center;
background:${({ theme, selected }) => selected ? theme.moodIcon.backgroundSelected : theme.moodIcon.background};
border-radius:100px;
padding:10px;
svg{
width:24px;
height:24px;
fill:${({ theme, selected }) => selected ? theme.moodIcon.colorSelected : theme.moodIcon.color};
}
`
const InfoText = styled.p`
font-weight: 500;
font-size: 14px;
line-height: 16px;
letter-spacing: -0.41px;
text-align: center;
vertical-align: middle;
color:${({ theme }) => theme.menu.infoText};
`